"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Helper method to create custom middleware. It makes possible to create middleware using user stores, so that it could call other actions.
 */
function createMiddleware(initMiddleware, contexts) {
    if (contexts === void 0) { contexts = {}; }
    return {
        initMiddleware: initMiddleware,
        contexts: contexts
    };
}
exports.createMiddleware = createMiddleware;
/**
 * @hidden Internal method which runs an action with all the provided middleware
 */
function runWithMiddleware(middleware, actions, args, meta) {
    var first = middleware[0], rest = middleware.slice(1);
    var action = actions[meta.actionName];
    if (first === undefined)
        return actionCaller(action, actions)(args);
    return first(function (nextArgs) { return runWithMiddleware(rest, actions, nextArgs, meta); }, args, meta);
}
exports.runWithMiddleware = runWithMiddleware;
var actionCaller = function (action, actions) { return function (args) { return action.call.apply(action, [actions].concat(args)); }; };



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-concise-state/dist/middleware.js
// module id = 213
// module chunks = 0